import type { IAssetMedia } from '@/redux/features/trackingPageMedia.slice';

export interface IMediaUploadRequest {
  name: string;
  file?: File | null;
  url?: string;
  isUrlOnly: boolean;
}

/**
 * Decide which media assets actually need to be pushed to the backend on save.
 * Pure so the save handler can build a real list of awaitable requests (the old
 * inline version forgot to `return` the file-upload promise, so `Promise.all`
 * never waited for it).
 */
export const getMediaUploadRequests = (data?: IAssetMedia, oldData?: IAssetMedia): IMediaUploadRequest[] => {
  if (!data || !oldData) return [];

  return Object.entries(data).flatMap(([key, media]) => {
    const oldAsset = oldData[key as keyof IAssetMedia];
    const isFileChange = !!media.file;
    const isUrlChange = !!media.value && media.value !== oldAsset?.url;
    if (!isFileChange && !isUrlChange) return [];

    return [
      {
        name: `asset-${media.index}`,
        file: media.file,
        url: media.value,
        isUrlOnly: !media.file && isUrlChange,
      },
    ];
  });
};
